import { SearchResourceDictionaryService } from "@app/core/services/resource-dictionary/search-resource-dictionary.service";
import { RunsStore } from "@app/core/store/runs/runs.store";
import { DataTableUtilities } from "@app/core/utilities/data-table-utilities";
import { BsshDatePipe } from "@app/core/utilities/pipes/bssh-date.pipe";
import { RadLinkRendererComponent } from "@app/shared/cell-renderers/rad-link-renderer/rad-link-renderer.component";
import { RunSearchColumnFields, RunSearchGridOptionsFormatter } from "@app/search/gridOptions/run-search-grid-options-formatter";
import { OverrideColumnDefinition, OverrideColumnParameters } from "@app/search/gridOptions/search-grid-options-formatter";

// Inheriting from RunSearchGridOptionsFormatter because chooser uses search api, datasource, and table columns
export class RunChooserGridOptionsFormatter extends RunSearchGridOptionsFormatter {
    constructor(
        public resourceDictionaryService: SearchResourceDictionaryService,
        public bsshDatePipe: BsshDatePipe,
        public runsStore: RunsStore,
    ) {
        super(resourceDictionaryService, bsshDatePipe, runsStore);
    }

    protected getOverrideColumnParameters(): OverrideColumnParameters<RunSearchColumnFields> {
        const inclusiveColumns: RunSearchColumnFields[] = [
            RunSearchColumnFields.Name,
            RunSearchColumnFields.Owner,
            RunSearchColumnFields.Instrument,
            RunSearchColumnFields.Status,
            RunSearchColumnFields.Created
        ];
        
        const overrideColumnDefinitions: OverrideColumnDefinition<RunSearchColumnFields>[] = [
            {
                headerName: 'Name',
                field: 'Run.ExperimentName',
                cellRendererFramework: RadLinkRendererComponent,
                cellRendererParams: (params: any) => {
                    if(params.data) {
                        const tooltipText = !this.isRowSelectable(params.node) ? this.getUnselectableRowMessage(params.node) : null;
                        const cellRendererParams = DataTableUtilities.getRadLinkParams(
                            params.data.Run.ExperimentName,
                            this.resourceConfig.uiHrefAccessor(params.data),
                            tooltipText,
                            '_blank',
                            60
                        );

                        return cellRendererParams;
                    } else {
                        return {};
                    }
                },
                colId: RunSearchColumnFields.Name,
                showAlways: true,
                sortable: false,
                filterActive: false,
            }
        ];

        return {
            inclusiveColumns,
            overrideColumnDefinitions
        };
    }
}